import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { bindActionCreators, ActionCreatorsMapObject } from 'redux';
import LoginForm from './LoginForm';
import LoginLogo from './LoginLogo';
import { authTokenAsync, AuthTokenActionCreator, AuthTokenAsyncActionCreator } from '../../actions';
import { AuthResponse } from '../../api/model';
import { RoutePath } from '../../routes/RoutePath';
import { StoreState } from '../../store';

//#region UI configuration
//#endregion

//#region Props & State
interface LoginPageStateProps { }
interface LoginPageDispatchProps {
    readonly authToken: (userName: string, password: string) => Promise<AuthResponse>;
}
interface LoginPageProps extends RouteComponentProps<void>, LoginPageStateProps, LoginPageDispatchProps { }
interface LoginPageState { }
//#endregion

class LoginPage extends React.Component<LoginPageProps, LoginPageState> {

    render() {
        return (
            <React.Fragment>
                <LoginLogo />
                <LoginForm submit={this.submit} />
            </React.Fragment>
        );
    }

    //#region Private
    submit = (userName: string, password: string) => {
        return this.props.authToken(userName, password)
            .then(() => {
                this.props.history.push(RoutePath.HomePage);
                Promise.resolve();
            }
            );
    }
    //#endregion
}

//#region Connect
interface DispatchAyncActionCreators extends ActionCreatorsMapObject {
    authToken: AuthTokenAsyncActionCreator;
}

interface DispatchActionCreators extends ActionCreatorsMapObject {
    authToken: AuthTokenActionCreator;
}

const mapStateToProps = (state: StoreState): LoginPageStateProps => ({});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) =>
    bindActionCreators<DispatchAyncActionCreators, DispatchActionCreators>({ authToken: authTokenAsync }, dispatch);

export default connect<LoginPageStateProps, LoginPageDispatchProps>(mapStateToProps, mapDispatchToProps)(LoginPage);
//#endregion



// WEBPACK FOOTER //
// ./src/modules/login/LoginPage.tsx